import { render, staticRenderFns } from "./MailScheduleContentInfo.vue?vue&type=template&id=4891bb24&"
import script from "./MailScheduleContentInfo.vue?vue&type=script&lang=ts&"
export * from "./MailScheduleContentInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports